<template>
  <div class="">
    <el-row v-loading="loading" class="home-top" :gutter="40">
      <el-col :xs="24" :sm="12" :md="8" :lg="8" class="home-top-col">
        <div class="home-top-right">
          <div class="spaceBetween mb-60">
            <div class="home-top_text-1">Cumulative Minted Rep</div>
          </div>
          <el-row>
            <!-- <el-col :xs="24" :sm="12" :md="10" :lg="10">
              <div class="home-top-chart">
                <PieChart :chartData.sync="chartData"/>
              </div>
            </el-col> -->
            <el-col :xs="24" :sm="12" :md="14" :lg="14">
              <div style="display: flex;align-items: center;">
                <div class="spaceLeft home-top-right_title">
                  <img src="@/assets/image/home/img-1.png">
                  <!-- <span class="home-top_text-2">Rep</span> -->
                </div>
                <div style="display: flex;align-items: baseline;" class="text-num-big">
                  <big-number :number="total" />
                  <span style="margin-left: 0.1rem;" class="home-top_text-2 ml-8">Rep</span>
                </div>
              </div>
              <!-- <div class="spaceBetween home-top-right_item">
                <div>
                  <span class="block color-1"></span>
                  <span>Minted by Minerals</span>
                </div>
                <div>
                  <span class="text-num">
                    {{ splitK(getChartDataItem('Minted by Minerals')) }}
                  </span>
                  <span>Rep</span>
                </div>
              </div>
              <div class="spaceBetween home-top-right_item">
                <div>
                  <span class="block color-2"></span>
                  <span>Minted by ETH</span>
                </div>
                <div>
                  <span class="text-num">
                    <big-number :number="getChartDataItem('Minted by ETH')"/>
                  </span>
                  <span>Rep</span>
                </div>
              </div>
              <div class="spaceBetween home-top-right_item">
                <div>
                  <span class="block color-3"></span>
                  <span>Minted by BTC</span>
                </div>
                <div>
                  <span class="text-num">
                    <big-number :number="getChartDataItem('Minted by BTC')"/>
                  </span>
                  <span>Rep</span>
                </div>
              </div> -->
            </el-col>
          </el-row>
          <div style="position: absolute;bottom: 20px;text-align: center;" class="home-top_btn" @click="totat()">View Details</div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" class="home-top-col">
        <div class="home-top_left">
          <div class="spaceBetween mb-60">
            <div class="home-top_text-1" style="color: rgb(93, 94, 95);">My Expenses</div>
            <div class="home-top_btn" style="color: #5D5E5F;border-radius: 1rem;" @click="toexpense()">View Details
            </div>
          </div>
          <div class="home-top_text-2 mb-16" style="color: #5D5E5F;">Balance</div>
          <div class="home-top_text-3 mb-32">
            <div>
              <span class="home-top_text-2 mb-16" style="color: #5D5E5F;">Oil</span>
              <big-number style="color: #1F1C2C;" :number="balance" />
              <span style="color: #65646A;" class="home-top_text-2"> Unit</span>
            </div>
            <div>
              <span class="home-top_text-2 mb-16" style="color: #5D5E5F;">Gas</span>
              <big-number style="color: #1F1C2C;" :number="balance2" />
              <span style="color: #65646A;" class="home-top_text-2"> Unit</span>
            </div>

          </div>
          <div v-if="expense.timestamp" class="home-top_text-4">The next audit is on
            <span>{{ moment(expense.timestamp).format("YYYY/MM/DD") }}</span>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" :md="8" :lg="8" class="home-top-col">
        <div class="home-top_middle">
          <div class="spaceBetween mb-60">
            <div class="home-top_text-1" style="color: #5D5E5F;">Number of Wells</div>
            <div class="home-top_btn" style="color: #5D5E5F;border-radius: 1rem;" @click="toWells()">View Details</div>
          </div>
          <div class="wells-container">
            <div class="wells-numbers">
              <div class="well-item">
                <div class="well-number">{{ OILTotal }}</div>
                <div class="well-label">Oil Wells</div>
              </div>
              <div class="well-item">
                <div class="well-number">{{ GASTotal }}</div>
                <div class="well-label">Gas Wells</div>
              </div>
            </div>
            <div class="wells-progress">
              <div class="well-progress-bar oil-progress" :style="{ width: oilPercentage + '%' }" />
              <div class="well-progress-bar gas-progress" :style="{ width: gasPercentage + '%' }" />
            </div>
          </div>
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
/* global web3 */
import { marginList } from '@/api/expenseMansgement'
import { splitK, toBigItem, toSmallItem } from '@/utils/bigNumberTran.js'
import { mapGetters } from 'vuex'
import { wellList } from '@/api/well.js'
export default {
  data() {
    return {
      chartData: [
        {
          'value': 0,
          'name': 'Minted by Minerals'
        },
        {
          'value': 0,
          'name': 'Minted by ETH'
        },
        {
          'value': 0,
          'name': 'Minted by BTC'
        }
      ],
      balance: 0,
      balance2: 0,
      loading: false,
      expense: {},
      splitK: splitK,
      OILTotal: 0,
      GASTotal: 0
    }
  },
  computed: {
    ...mapGetters(['metaMaskObj', 'contractMap']),
    total() {
      let sum = new this.BigNumber(0)
      this.chartData.forEach(i => {
        let data = i.value
        if (i.name === 'Minted by Minerals') {
          data = toBigItem(i.value)
        }
        sum = sum.plus(data)
      })
      return sum
    },
    oilPercentage() {
      const total = this.OILTotal + this.GASTotal
      return total > 0 ? (this.OILTotal / total) * 100 : 50
    },
    gasPercentage() {
      const total = this.OILTotal + this.GASTotal
      return total > 0 ? (this.GASTotal / total) * 100 : 50
    }
  },
  mounted() {
    this.getWellList()
    this.getData()
    this.queryDepositBalance()
  },
  methods: {
    async getWellList() {
      const OILRes = await wellList({
        account: this.metaMaskObj.account,
        page: 1,
        pageSize: 1,
        type: 'OIL',
        status: 1
      })
      console.log('OILRes', OILRes.result.total)
      this.OILTotal = OILRes.result.total
      const GASRes = await wellList({
        account: this.metaMaskObj.account,
        page: 1,
        pageSize: 1,
        type: 'GAS',
        status: 1
      })
      console.log('GASRes', GASRes.result.total)
      this.GASTotal = GASRes.result.total
    },
    async queryDepositBalance() {
      try {
        /* this.contractExpense = this.contractMap["contractExpense"].contract;
        this.contractExpenseAddress = this.contractMap["contractExpense"].address;
        if(this.contractExpense){
          let res = await this.contractExpense.methods["queryAccountData"](this.metaMaskObj.account).call({
            from: this.metaMaskObj.account
          });
          this.balance = res.Margin || "0";
        }*/

        const abi = await this.getAbi('OilData')
        const contract = new web3.eth.Contract(abi.data.abi, abi.data.address)
        const res = await contract.methods['marginOf'](
          this.metaMaskObj.account
        ).call({
          from: this.metaMaskObj.account
        })
        this.balance = res[0]
        this.balanceType = res[1]
        this.balance = res[1] ? res[0] : 0 - res[0]

        const abi2 = await this.getAbi('GasData')
        const contract2 = new web3.eth.Contract(abi2.data.abi, abi2.data.address)
        const res2 = await contract2.methods['marginOf'](
          this.metaMaskObj.account
        ).call({
          from: this.metaMaskObj.account
        })
        this.balance2 = res2[0]
        this.balanceType2 = res2[1]
        this.balance2 = res2[1] ? res2[0] : 0 - res2[0]
      } catch (e) {
        console.log(e)
      }
    },
    async getData() {
      this.loading = true
      const abi = await this.getAbi('TAT')
      const contract = new web3.eth.Contract(abi.data.abi, abi.data.address)
      const res = await contract.methods['balanceOf'](
        this.metaMaskObj.account
      ).call({
        from: this.metaMaskObj.account
      })
      console.log('balanceOf', res)
      this.chartData = [
        {
          'value': toSmallItem(res),
          'name': 'Minted by Minerals'
        },
        {
          'value': 0,
          'name': 'Minted by ETH'
        },
        {
          'value': 0,
          'name': 'Minted by BTC'
        }
      ]
      this.loading = false
    },
    getChartDataItem(type) {
      const item = this.chartData.find(i => i.name === type) || {}
      return item.value
    },
    toexpense() {
      this.$router.push('/expenseMansgement/index')
    },
    totat() {
      this.$router.push('/Rep/index')
    },
    toWells() {
      this.$router.push('/wellManagement/myWells')
    },
    getMarginList() {
      const json = {
        account: this.metaMaskObj.account,
        page: 1,
        pageSize: 1
      }
      marginList(json).then((res) => {
        this.expense = (res.data && res.data.data && res.data.data[0]) || {}
      })
    }
  }
}
</script>
<style scoped lang="scss">
.home-top {
  .home-top-col {
    display: flex;
    flex-direction: column;
  }

  .home-top_left {
    padding: 0.28rem 0.4rem;
    background: white;
    background-size: 100% 100%;
    min-height: 3.4rem;
    border-radius: 0.2rem;
    box-shadow: 0 12px 24px 0 rgba(166, 168, 172, 0.35);
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .home-top_middle {
    padding: 0.28rem 0.4rem;
    background: linear-gradient(180deg, #ffffff 0%, #fffbfb 100%);
    background-size: 100% 100%;
    min-height: 3.4rem;
    border-radius: 0.2rem;
    box-shadow: 0 12px 24px 0 rgba(166, 168, 172, 0.35);
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .home-top_text-1 {
    font-size: 0.32rem;
    font-weight: 500;
    font-family: Roboto-Medium;
    color: #ffffff;
    line-height: 0.32rem;
  }

  .home-top_text-2 {
    font-size: 0.24rem;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.28rem;
  }

  .home-top_text-3 {
    font-size: 0.44rem;
    font-weight: 500;
    font-family: Roboto-Medium;
    color: #ffffff;
    line-height: 0.52rem;
  }

  .home-top_text-4 {
    font-size: 0.22rem;
    font-weight: 400;
    color: #ffffff;
    line-height: 0.28rem;
  }

  .home-top_btn {
    cursor: pointer;
    padding: 0.1rem 0.2rem;
    font-size: 0.16rem;
    font-weight: 500;
    font-family: Roboto-Medium;
    color: #ffffff;
    border-radius: 0.04rem;
    border: 0.01rem solid #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(204, 204, 204, 0.35);
  }

  .home-top-right {
    padding: 0.28rem 0.4rem;
    background: url("../../assets/image/home/bg-1.png") no-repeat;
    background-size: 100% 100%;
    min-height: 3.4rem;
    border-radius: 0.2rem;
    box-shadow: 0 12px 24px 0 rgba(166, 168, 172, 0.35);
    flex: 1;
    display: flex;
    flex-direction: column;

    .home-top_text-1 {
      color: #ffffff;
    }

    .home-top_btn {
      color: #ffffff;
      border-color: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(204, 204, 204, 0.35);
    }
  }

  .home-top-right_title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.18rem;
    margin-bottom: 0.08rem;
    margin-top: 0.06rem;

    img {
      margin-right: 0.08rem;
      width: 0.32rem;
    }
  }

  .text-num-big {
    color: #ffffff;
    font-size: 0.44rem;
    font-weight: 500;
    font-family: Roboto-Medium;
    line-height: 0.52rem;
  }

  .home-top-right_item {
    font-size: 0.18rem;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 0.12rem;

    .text-num {
      color: rgba(0, 0, 0, 0.85);
    }

    .block {
      display: inline-block;
      width: 0.16rem;
      height: 0.16rem;
      border-radius: 0.04rem;

      &.color-1 {
        // background: #f0426c;
        background: #38F4BA;
      }

      &.color-2 {
        background: #59bffa;
      }

      &.color-3 {
        background: #2f69eb;
      }
    }
  }

  .home-top-chart {
    width: 2.16rem;
    margin-top: 0.1rem;
  }

  .wells-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.32rem;
  }

  .wells-numbers {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .well-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .well-number {
    font-size: 0.44rem;
    font-weight: 700;
    color: #2D2D2D;
    line-height: 1;
    margin-bottom: 0.08rem;
  }

  .well-label {
    font-size: 0.24rem;
    color: #929DAD;
  }

  .wells-progress {
    display: flex;
    width: 100%;
    height: 0.16rem;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #E8E9EA;
  }

  .well-progress-bar {
    height: 100%;
    transition: width 0.3s ease;
  }

  .oil-progress {
    background: linear-gradient(90deg, #4F7CFF 0%, #5B8CFF 100%);
  }

  .gas-progress {
    background: linear-gradient(90deg, #4DFFA6 0%, #6FFFC0 100%);
  }
}
</style>
